<form (ngSubmit)="onSubmit()" [formGroup]="passwordResetForm" autocomplete="off" class="w-full flex flex-col gap-4">
  <syn-validate on="live" variant="inline" [customValidationMessage]="validationMessageService.byName(passwordResetForm, 'password')">
    <syn-input
      class="w-full"
      formControlName="password"
      name="password"
      [label]="('passwordReset.newPassword' | translate) + ' *'"
      [title]="'passwordReset.newPassword' | translate"
      [placeholder]="'passwordReset.enterNewPassword' | translate"
      type="password"
      passwordToggle
      autocomplete="new-password"
      required
    >
    </syn-input>
  </syn-validate>

  <syn-validate on="live" variant="inline" [customValidationMessage]="validationMessageService.byName(passwordResetForm, 'confirmedPassword')">
    <syn-input
      class="w-full"
      formControlName="confirmedPassword"
      name="confirmedPassword"
      [label]="('passwordReset.confirmedPassword' | translate) + ' *'"
      [title]="'passwordReset.confirmedPassword' | translate"
      [placeholder]="'passwordReset.reEnterNewPassword' | translate"
      type="password"
      passwordToggle
      autocomplete="new-password"
      required
    >
    </syn-input>
  </syn-validate>

  <syn-button
    [attr.disabled]="disableSubmitForm || null"
    variant="filled"
    type="submit"
    id="resetPasswordButton"
    style="width: 100%"
  >
    <syn-icon slot="prefix" name="lock_reset" aria-hidden="true"></syn-icon>
    {{ 'action.resetPassword' | translate }}
  </syn-button>
</form>
